import * as React from 'react';
import { Props } from '../../../types/props';

const FormBody = ({ children, className }: Props) => {
  return <div className={`form-body ${className}`}>{children}</div>;
};


export default FormBody;